import { CustomerMethodologyPage } from "../../components/CustomerMethodologyPage";

export function ClinicalToolkitMethodology() {
  return (
    <CustomerMethodologyPage
      title="Clinical toolkit — overview"
      description="How WeConsult Rx clinical calculators and reference tools support consultant pharmacist workflows."
      path="/trust/clinical-toolkit-methodology"
    >
      <p>
        The clinical toolkit provides calculators and reference tables that
        consultant pharmacists use during chart review — renal dose adjustment,
        anticholinergic burden scoring, and related clinical decision aids.
      </p>
      <h2>What it covers</h2>
      <ul>
        <li>Renal dose adjustment by creatinine clearance range.</li>
        <li>Anticholinergic burden (ACB) scoring.</li>
        <li>Reference tables anchored to published clinical sources.</li>
      </ul>
      <h2>How it helps</h2>
      <p>
        Tools are available in-context during review so pharmacists can apply
        published criteria without switching to external references.
      </p>
    </CustomerMethodologyPage>
  );
}
